export class NetworkUtils {

    /**
     * Verifica se un URL appartiene all'indirizzo di loopback (localhost)
     */
    static isLoopback(url: string): boolean {
        try {
            const parsed = new URL(url);
            const hostname = parsed.hostname;
            return hostname === 'localhost' ||
                hostname === '127.0.0.1' ||
                hostname.startsWith('127.') ||
                hostname === '[::1]'; // IPv6 loopback
        } catch {
            return false;
        }
    }
}